export default "__VITE_ASSET__aBkrOc$Y__"